import { FC } from 'react'
import { useInstrumentsLogic } from './Instruments.logic'
import { Checkbox, FormControlLabel, Grid } from '@mui/material'
import { INSTRUMENTS_OPTIONS, TInstrumentsProps } from './Instruments.types'

export const Instruments: FC<TInstrumentsProps> = (props) => {
  const logic = useInstrumentsLogic(props)

  return (
    <Grid container spacing={1}>
      {INSTRUMENTS_OPTIONS.map((option, index) => (
        <Grid key={index} item xs={12} sm={6} md={4} lg={3} xl={2}>
          <FormControlLabel
            label={option}
            control={
              <Checkbox
                checked={logic.selectedOptions.includes(option)}
                onChange={() => logic.handleCheckboxChange(option)}
              />
            }
          />
        </Grid>
      ))}
    </Grid>
  )
}
